import React from 'react'
import Layout from '../components/layout'
import SectionDiv from '../components/section-div'



const ProvablyHonest = () => (
    <Layout>
        <SectionDiv>
            <h1>blindmixer is Provably Honest</h1>
            <p>Every action is digitally signed for both parties in an audit log.</p>
            <p>
                Having this done, makes any transaction made by you <i>non-repudiable</i> by us, so you can always have a way to prove we are being honest about the transactions that have been held.
            </p>
        </SectionDiv>
    </Layout>
)

export default ProvablyHonest
